import { EXCEL_COLUMNS_COLOR } from './constants'
const ExcelJS = require('exceljs')

const dummyData = [
  {
    name: 'Page 1',
    data: [
      {
        A: {
          v: 'Comparison Approval (preview)',
          s: { bold: true, color: { argb: 'FF0000FF' } },
        },
        B: { v: '' },
      },
      { A: { v: ' ', s: {} }, B: { v: '' } },
      {
        A: { v: 'Process Reference', s: { bold: true } },
        B: { v: 'PKG-1079', s: {} },
      },
      { A: { v: 'Version', s: {} }, B: { v: 1, s: {} } },
    ],
  },
  {
    name: 'Page 2',
    columnsWidth: { A: 30, B: 30 }, // column's width
    data: [
      {
        A: {
          v: 'Comparison Approval (preview)',
          s: { bold: true, color: { argb: 'FF0000FF' } },
        },
        B: { v: '' },
      },
      { A: { v: ' ', s: {} }, B: { v: '' } },
      {
        A: { v: 'Process Reference', s: { bold: true } },
        B: { v: 'PKG-1079', s: {} },
      },
      { A: { v: 'Version', s: {} }, B: { v: 1, s: {} } },
    ],
  },
]

// Helper function to convert column letter to number
const columnLetterToNumber = (letter) => {
  if (!/^[A-Z]+$/.test(letter)) {
    throw new Error(`Invalid column letter: ${letter}`)
  }
  let column = 0
  const length = letter.length
  for (let i = 0; i < length; i++) {
    column += (letter.charCodeAt(i) - 64) * Math.pow(26, length - i - 1)
  }
  return column
}

export const downloadExcel = (sheetData = dummyData, filename, mergeCellData = []) => {
  const workbook = new ExcelJS.Workbook()
  const usedNames = new Map()

  sheetData.forEach((sheet) => {
    // Handle duplicate sheet names
    let baseName = sheet.name
    let sheetName = baseName
    let count = usedNames.get(baseName) || 0

    while (usedNames.has(sheetName)) {
      count += 1
      sheetName = `${baseName} (${count})`
    }

    usedNames.set(baseName, count)
    usedNames.set(sheetName, 0)

    const worksheet = workbook.addWorksheet(sheetName)

    // Handle merged header cells
    if (mergeCellData.length > 0) {
      mergeCellData.forEach((header, index) => {
        try {
          worksheet.mergeCells(`${header.from}:${header.to}`)
          const cell = worksheet.getCell(header.from)

          cell.alignment = {
            horizontal: 'center',
            vertical: 'middle',
          }
          cell.font = { bold: true }

          const colorIndex = index % EXCEL_COLUMNS_COLOR.length
          const color = EXCEL_COLUMNS_COLOR[colorIndex]
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: `FF${color}` },
          }

          cell.value = header.name
        } catch (error) {
          console.error(`Error merging cells from ${header.from} to ${header.to}:`, error)
        }
      })
    }

    // Add data rows
    sheet.data.forEach((row, index) => {
      const rowNum = index + 1
      const excelRow = worksheet.getRow(rowNum)

      Object.keys(row).forEach((col) => {
        try {
          const colNum = columnLetterToNumber(col)
          const cell = excelRow.getCell(colNum)

          if (row[col].v) {
            cell.value = row[col].v
          }

          if (row[col].numFmt) {
            cell.numFmt = row[col].numFmt
          }

          if (row[col].s && Object.keys(row[col].s).length > 0) {
            if (row[col].s.bold) {
              cell.font = { bold: true }
            }

            if (row[col].s.color) {
              cell.font = cell.font || {}
              cell.font.color = row[col].s.color
            }
          }
        } catch (error) {
          console.error(`Error processing column ${col}:`, error)
        }
      })
    })

    // Set default column width
    worksheet.columns?.forEach((column) => {
      column.width = 20
    })

    // Override column widths if specified
    if (sheet.columnsWidth) {
      Object.entries(sheet.columnsWidth).forEach(([key, value]) => {
        try {
          const colNum = columnLetterToNumber(key)
          worksheet.getColumn(colNum).width = value
        } catch (error) {
          console.error(`Error setting column width for ${key}:`, error)
        }
      })
    }
  })

  // Write and download workbook
  workbook.xlsx
    .writeBuffer()
    .then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename + '.xlsx'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
    })
    .catch((error) => {
      console.log('Error:', error)
    })
}
